import React from 'react'
import { RiNotificationLine, RiFullscreenFill, RiLogoutCircleLine } from 'react-icons/ri';
import Cookies from 'js-cookie';
import { useNavigate, Link } from 'react-router-dom';

const Topbar = () => {
  const navigate = useNavigate()
  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };

  const handleLogout = (e) => {
    e.preventDefault()
    Cookies.remove('token')
    navigate('/')
  }

  return (
    <div>
      <>{ /* app-header */ }
        <div className="app-header-area">
            <header className="app-header" id="header">
                <div className="app-header-inner">
                    <div className="app-header-left">
                        <div className="d-flex align-center gap-15">
                            <div className="app-header-element">
                                <a className="sidebar-toggle-bar" id="sidebarToggle" href="javascript:void(0);">
                                    <div className="sidebar-menu-bar">
                                        <span />
                                        <span />
                                        <span />
                                    </div>
                                </a>
                            </div>
                            <div className="app-header-ls-logo">
                                { /* large screen logo */ }
                                <a className="app-header-ls-dark-logo" href="/">
                                    <img src="/assets/images/burray/burray.png" alt="image" />
                                </a>
                                <a className="app-header-ls-light-logo" href="/">
                                    <img src="/assets/images/burray/burray.png" alt="image" />
                                </a>
                            </div>
                            <div className="app-header-mobile-logo">
                                <a className="app-header-dark-logo" href="/">
                                    <img src="/assets/images/burray/burray.png" alt="image" />
                                </a>
                                <a className="app-header-light-logo" href="/">
                                    <img src="/assets/images/burray/burray.png" alt="image" />
                                </a>
                            </div>
                        </div>
                        
                    </div>
                    <div className="app-header-right">
                        <div className="app-header-search-modal">
                            <button type="button" className="app-header-circle" data-bs-toggle="modal" data-bs-target="#searchModal">
                                <i className="ri-search-line" />
                            </button>
                        </div>
                        


                        <div className="app-header-fullscreen app-header-circle cursor-pointer">
                            <div onClick={toggleFullScreen}>
                                <RiFullscreenFill />
                            </div>
                        </div>

                        <div className="app-header-notification">
                            <div className="dropdown">
                                <a className="dropdown-toggle" href="javascript:void(0);" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <span className="app-header-circle"><RiNotificationLine /></span>
                                </a>
                                
                            </div>
                        </div>

                        <div className="app-header-user">
                            <div className="dropdown">
                                <a className="dropdown-toggle" href="javascript:void(0);" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <div className="author">
                                        <div className="author-thumb">
                                            <img src="/assets/images/avatar/avatar-thumb-dummy.png" alt="user" />
                                        </div>
                                        <h6 className="author-name lh-1">System Admin</h6>
                                    </div>
                                </a>
                                <ul className="dropdown-menu">
                                    <li><RiLogoutCircleLine /> <Link to="" onClick={handleLogout}>Logout</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <div className="body__overlay" />
        </div>
        { /* app-header */ }</>
    </div>
  )
}

export default Topbar